import { FiCheckCircle } from "react-icons/fi";
import "./style.scss";
import { Link } from "react-router-dom";
import Button from "../Button";

const CertificateCard = ({
  title,
  level,
  duration,
  questions,
  showIcon = true,
  disabled = false,
}) => {
  return (
    <div className="col-lg-4 col-md-6 mb-3">
      <div className="card custom-card-certificate h-100 hover-card">
        <div className="card-body">
          {/* Title + Icon */}
          <div className="d-flex justify-content-between align-items-start mb-3">
            <h6 className="fw-bold text-light mb-0">{title}</h6>
            {showIcon && <FiCheckCircle className="text-accent" size={18} />}
          </div>

          {/* Level */}
          <p className="text-muted small mb-3">{level}</p>

          {/* Duration + Questions */}
          <div className="row mb-3">
            <div className="col-6">
              <small className="text-muted">Duration</small>
              <div className="text-light small">{duration}</div>
            </div>
            <div className="col-6">
              <small className="text-muted">Questions</small>
              <div className="text-light small">{questions}</div>
            </div>
          </div>

          {/* Button */}
          <Link to={`/certificate/${title}`}>
            <Button variant="gradient" fullWidth disabled={disabled}>
              Start Assessment
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CertificateCard;
